import React, { memo, useId } from 'react';

/**
 * Decorative illustration for the product unit relations empty state.
 */
const ProductUnitRelationsEmptyIllustration = memo((props) => {
    const reactId = useId();
    const maskId = `product-unit-relations-empty-mask-${reactId.replace(/:/g, '')}`;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={144}
            height={144}
            fill="none"
            aria-hidden
            {...props}
        >
            <mask
                id={maskId}
                width={132}
                height={102}
                x={6}
                y={21}
                maskUnits="userSpaceOnUse"
                style={{
                    maskType: 'luminance',
                }}
            >
                <path fill="#fff" d="M137.506 21.177H6.494v101.647h131.012z" />
            </mask>
            <g mask={`url(#${maskId})`}>
                <path
                    fill="#00d041"
                    d="M47.37 91.796a3.86 3.86 0 0 1-2.928-1.343L33.759 78.031a3.845 3.845 0 0 1 .414-5.43 3.86 3.86 0 0 1 5.438.413l8.268 9.616 43.514-34.413a3.86 3.86 0 0 1 5.418.628 3.846 3.846 0 0 1-.629 5.409L49.764 90.963a3.85 3.85 0 0 1-2.393.831z"
                />
                <path
                    fill="#c6c6c6"
                    d="M113.669 52.758a4.29 4.29 0 0 1-4.291-4.169 4.29 4.29 0 0 1 4.174-4.404l1.698-.046 1.929-8.674c1.011-4.55 4.978-7.726 9.645-7.726a4.29 4.29 0 0 1 4.295 4.287 4.29 4.29 0 0 1-4.295 4.288c-.61 0-1.128.415-1.261 1.01l-2.654 11.939a4.29 4.29 0 0 1-4.073 3.356l-5.045.14h-.122z"
                />
                <path
                    fill="#919191"
                    d="M21.007 89.493h53.518a5.45 5.45 0 0 1 5.45 5.441v3.108H15.557v-3.108a5.45 5.45 0 0 1 5.45-5.441"
                />
                <path
                    fill="#474747"
                    d="M85.979 94.99H9.552a3.055 3.055 0 0 0-3.058 3.05 3.055 3.055 0 0 0 3.058 3.053h76.427a3.055 3.055 0 0 0 3.057-3.052 3.055 3.055 0 0 0-3.057-3.052"
                />
                <path
                    fill="#5e5e5e"
                    d="M131.835 120.707a5.663 5.663 0 0 1-5.665-5.53l-1.21-53.154-13.51 52.337a5.67 5.67 0 0 1-6.904 4.068 5.66 5.66 0 0 1-4.075-6.892l14.418-55.847.019-.067a10.88 10.88 0 0 1 4.167-5.886 10.9 10.9 0 0 1 6.942-1.977 10.84 10.84 0 0 1 7.158 3.294 10.8 10.8 0 0 1 3.042 7.26l1.288 56.606a5.663 5.663 0 0 1-5.538 5.787h-.13z"
                />
                <path
                    fill="#5e5e5e"
                    d="M125.516 122.823a1.075 1.075 0 0 1-.311-2.102l7.787-2.353a1.075 1.075 0 0 1 .621 2.056l-7.786 2.353a1 1 0 0 1-.313.046zm-20.14-4.281h-7.507a1.075 1.075 0 1 1 0-2.148h7.507a1.075 1.075 0 1 1 0 2.148"
                />
                <path
                    fill="#e84d4f"
                    d="M115.27 70.909a2.144 2.144 0 0 1-1.605-3.568l10.726-12.065a2.15 2.15 0 0 1 3.032-.18c.886.785.967 2.14.18 3.026l-10.725 12.066a2.15 2.15 0 0 1-1.607.72z"
                />
                <path
                    fill="#c6c6c6"
                    d="M132.424 50.604s-6.832 2.859-13.525-1.356l5.295-4.04 8.051 4.04z"
                />
                <path
                    fill="#c6c6c6"
                    d="M125.993 60.986a4.3 4.3 0 0 1-1.97-.48 4.285 4.285 0 0 1-1.842-5.778c2.244-4.33 4.817-9.88 5.106-11.31l.56-4.173c.216-1.61-.148-2.515-.371-2.768-.037-.041-.145-.165-.653-.165a4.29 4.29 0 0 1-4.295-4.287 4.29 4.29 0 0 1 4.295-4.287c2.841 0 5.37 1.099 7.118 3.093 2.07 2.362 2.929 5.755 2.419 9.552l-.572 4.264-.015.11c-.507 3.153-4.338 10.779-5.961 13.912a4.3 4.3 0 0 1-3.817 2.319z"
                />
                <path fill="#c6c6c6" d="M131.837 35.09h-10v12.067h10z" />
                <path
                    fill="#e84d4f"
                    d="M128.506 22.614a2.15 2.15 0 0 1-1.319 2.738 2.153 2.153 0 0 1-2.742-1.319 2.14 2.14 0 0 1 .249-1.912 2.16 2.16 0 0 1 3.346-.273c.203.213.363.47.467.765z"
                />
                <path
                    fill="#474747"
                    d="M126.309 21.742a4.7 4.7 0 0 0 .907-.432 2.14 2.14 0 0 0-2.436.693c.507 0 1.024-.082 1.529-.26"
                />
                <path
                    fill="#e84d4f"
                    d="M95.756 51.45a2.145 2.145 0 0 1-2.142-2.03 2.145 2.145 0 0 1 2.029-2.254l15.395-.825a2.15 2.15 0 0 1 2.259 2.025 2.146 2.146 0 0 1-2.029 2.255l-15.395.825z"
                />
                <path
                    fill="#e84d4f"
                    d="M97.933 49.409h-2.482a1.03 1.03 0 0 1-1.03-1.03 1.03 1.03 0 0 1 1.03-1.028h2.482c.57 0 1.031.461 1.031 1.029a1.03 1.03 0 0 1-1.03 1.029"
                />
            </g>
        </svg>
    );
});

ProductUnitRelationsEmptyIllustration.displayName = 'ProductUnitRelationsEmptyIllustration';

export default ProductUnitRelationsEmptyIllustration;
